import React, { useEffect, useState } from 'react';
import '../styles/Carrito.css';
import { API_URL } from '../config';


type Producto = {
  nombre: string;
  sku?: string;
  imagen: string;
  color: string;
  cantidad: number;
  precio: number;
};

const Carrito: React.FC = () => {
  const [carrito, setCarrito] = useState<Producto[]>([]);
  const [stock, setStock] = useState<Record<string, number>>({});

  const guardarCarrito = (nuevo: Producto[]) => {
    localStorage.setItem('carrito', JSON.stringify(nuevo));
    setCarrito(nuevo);
    (window as any).actualizarCantidadCarrito?.();
  };

  // Cargar carrito desde localStorage
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('carrito') || '[]');
    setCarrito(items);
  }, []);

  // Cargar stock real desde backend (interno, no se muestra)
  useEffect(() => {
    const fetchStock = async () => {
      if (carrito.length === 0) return;
      try {
        const sku = carrito[0]?.sku || 'PREM-SHAKER-650';
        const res = await fetch(`${API_URL}/api/products/${sku}/availability`);
        const data = await res.json();
        setStock(data.stock || {});
      } catch (err) {
        console.error('Error al obtener stock del backend');
      }
    };
    fetchStock();
  }, [carrito]);

  const cambiarCantidad = (index: number, delta: number) => {
    const copia = [...carrito];
    const item = copia[index];
    const disponible = stock[item.color] ?? Infinity;

    // Verificación de stock (solo interna)
    if (delta > 0 && item.cantidad + 1 > disponible) {
      alert('No hay stock suficiente para este color.');
      return;
    }

    item.cantidad += delta;
    if (item.cantidad <= 0) copia.splice(index, 1);
    guardarCarrito(copia);
  };

  const eliminar = (index: number) => {
    const copia = [...carrito];
    copia.splice(index, 1);
    guardarCarrito(copia);
  };

  const total = carrito.reduce((acc, item) => acc + item.precio * item.cantidad, 0);

  return (
    <div className="carrito-container">
      <h2>Carrito de Compras</h2>

      {carrito.length === 0 ? (
        <p className="carrito-vacio">Tu carrito está vacío.</p>
      ) : (
        <>
          <ul className="carrito-lista">
            {carrito.map((item, index) => (
              <li key={index} className="carrito-item">
                <img src={item.imagen} alt={item.nombre} />
                <div>
                  <p className="nombre">
                    {item.nombre} {item.color ? `(${item.color})` : ''}
                  </p>
                  <p className="precio">Precio: ${item.precio.toLocaleString()}</p>
                  <div className="cantidad-controls">
                    <button onClick={() => cambiarCantidad(index, -1)}>-</button>
                    <span>{item.cantidad}</span>
                    <button onClick={() => cambiarCantidad(index, 1)}>+</button>
                    <button className="eliminar" onClick={() => eliminar(index)}>Eliminar</button>
                  </div>
                  {/* Eliminado: visualización del stock disponible */}
                </div>
              </li>
            ))}
          </ul>

          <div className="carrito-total">
            <strong>Total: ${total.toLocaleString()}</strong>
          </div>

          <div className="carrito-acciones">
            <button className="btn-secundario" onClick={() => (window.location.href = '/')}>
              Seguir comprando
            </button>
            <button
              className="btn-principal"
              onClick={() => {
                const token = localStorage.getItem('access_token');
                if (token) {
                  window.location.href = '/pago';
                } else {
                  window.location.href = '/login';
                }
              }}
            >
              Ir a pagar
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Carrito;
